import { ReactNode, useState } from 'react';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import LoadingIndicator from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { positionsBySport } from '@sorare/core/src/lib/positions';

import {
  PlayerDrawer,
  Props as PlayerDrawerProps,
} from 'components/player/PlayerDrawer';

import { Filters } from '../Filters';
import { Rows } from '../Rows';

type Props = {
  sport: Sport;
  PlayerDetails: PlayerDrawerProps['PlayerDetails'];
  options: {
    label: ReactNode;
    value: string;
    upcomingValue?: string;
  }[];
};

export const Grid = ({ sport, options, PlayerDetails }: Props) => {
  const [cardOpened, setCardOpened] = useState<{
    cardSlug: string;
    playerSlug: string;
  } | null>(null);

  const onStatsClick = (slug: string) =>
    setCardOpened({ cardSlug: '', playerSlug: slug });

  const [selected, setSelected] = useState<{
    label: ReactNode;
    value: string;
    upcomingValue?: string;
  } | null>(null);

  if (!selected) {
    if (options.length > 0) {
      setSelected(options[0]);
    }
    return <LoadingIndicator fullHeight />;
  }

  return (
    <>
      <ContentWithStickyHeader
        header={
          <Filters
            options={options}
            selected={selected!}
            onChange={o => {
              setSelected(o);
            }}
          />
        }
      >
        <Rows
          so5LeagueSlug={selected.value}
          upcomingSo5LeagueSlug={selected.upcomingValue}
          sport={sport}
          positions={positionsBySport[sport]}
          onStatsClick={onStatsClick}
        />
      </ContentWithStickyHeader>

      <PlayerDrawer
        cardOpened={cardOpened}
        onClose={() => setCardOpened(null)}
        PlayerDetails={PlayerDetails}
      />
    </>
  );
};
